// extracted by mini-css-extract-plugin
module.exports = {"root":"videoPlayer_root__FfU73","player":"videoPlayer_player__1P_zi","messageOverlay":"videoPlayer_messageOverlay__cz4PP","messageText":"videoPlayer_messageText__0BgDp"};